import axios from 'axios'
import baseUrl from './base-url'
import { getValidUrl } from '../util'

export default function({ state }, { url, data, query, headers, withBaseUrl = true }) {
    if (query)
        url = url + '?' + Object.keys(query).map((q) => (q + '=' + query[q])).join('&')
    
    url = getValidUrl(url, state)

    //return
    const __url = withBaseUrl ? baseUrl + url : url
    return axios.post(__url, data || {}, {
            withCredentials: true,
            headers: headers ? headers : {}
        })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            if (! error.response)
                throw error
            // console.log('error', JSON.stringify(error.response.data, null, 4))
            throw error.response.data
        })
}
